<script>
  export let row = {};
  export let descriptionPropertyName = null;
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<div
  class="flex flex-row items-center justify-start tooltip-container tooltip tooltipPlacehodler"
  data-tip={descriptionPropertyName ? row[descriptionPropertyName] : row.description}
>
  <span class="three-lines-max-display text-left">
    {descriptionPropertyName ? row[descriptionPropertyName] : row.description}
  </span>
</div>

<style>
  .three-lines-max-display {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* number of lines to show */
    line-clamp: 3;
    -webkit-box-orient: vertical;
    margin-bottom: 0;
    cursor: pointer;
  }

  .tooltip-container::before {
    max-width: 360px;
    z-index: 5;
    padding: 16px;
    font-size: 15px;
    box-shadow: 0px 4px 10px rgba(62, 62, 62, 0.24);
  }
</style>
